import PropTypes from 'prop-types';

function ProgressBar(props) {
  const {
    progress,
    done,
    total,
    color,
  } = props;

  const progressPercent = Math.round(progress * 100);

  return (
    <>
      {/* Progress bar */}
      <div className="w-full bg-white border border-pxMedBlue rounded-full h-4 p-0.5">
        <div
          className="h-full rounded-full transition-all duration-100 ease-out"
          style={{
            width: `${progressPercent}%`,
            backgroundColor: color ?? '#95d3e5',
          }}
        />
      </div>

      {/* Progress text */}
      {done && (
        <div className="text-sm text-pxTxtMuted">
          {`${done} / ${total}`}
        </div>
      )}
    </>
  );
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  done: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  color: PropTypes.string,
};

export default ProgressBar;
